'use client'
import { GifPanelContext } from '@/app/components/detail/gif-panel-context-manager'
import GifDragDropOverlay from '@/app/components/gif-drag-drop-overlay'
import { IGif } from '@giphy/js-types'
import { useContext } from 'react'
type Props = { gif: IGif; width: number }

const SharePanel = ({ gif, width }: Props) => {
    const { panel } = useContext(GifPanelContext)
    return panel === 'share' ? <GifDragDropOverlay src={gif.images.original.url} width={width} /> : null
}

export default SharePanel
